// extracted by mini-css-extract-plugin
module.exports = {"header":"header__3vFa9","heading":"heading__1i1yS","centered":"centered__1qhX6"};